import { useState } from 'react';

interface FaqItem {
  question: string;
  answer: string;
}

const faqItems: FaqItem[] = [
  {
    question: '18网页游戏需要下载安装吗？',
    answer: '不需要！18网页游戏平台上的所有游戏都支持即点即玩，只需要浏览器就能畅快游戏，无需等待下载和安装，非常方便快捷。',
  },
  {
    question: '网页游戏是免费的吗？',
    answer: '平台上的大部分网页游戏都采用免费游玩模式。你可以免费体验核心内容，部分游戏提供可选的内购道具或加速服务，但完全不影响免费玩家的游戏体验。',
  },
  {
    question: '网页游戏画质怎么样？能和客户端游戏比吗？',
    answer: '随着HTML5和WebGL技术的飞速发展，现代网页游戏的画质已经大幅提升。许多精品网页游戏的画面表现已经非常接近甚至达到了一些客户端游戏的水准，尤其在我们精选推荐的高品质游戏中。',
  },
  {
    question: '我的电脑配置不高，能玩网页游戏吗？',
    answer: '完全没问题！相比需要安装的客户端游戏，网页游戏对硬件配置的要求低很多。只要你的电脑能流畅浏览网页、观看在线视频，就基本能畅玩平台上的绝大多数游戏。',
  },
  {
    question: '18网页游戏支持手机游玩吗？',
    answer: '我们平台持续收录支持移动端适配的优质网页游戏。你可以通过手机浏览器直接访问并游玩，无需下载App，方便随时随地开启游戏体验。',
  },
  {
    question: '平台上游戏安全吗？会不会有病毒？',
    answer: '18网页游戏平台严格筛选所有上架游戏，确保每款游戏都经过安全审核。网页游戏在浏览器沙盒环境中运行，不会对您的设备造成安全威胁，请放心游玩。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于网页游戏的常见疑问，这里都有答案
          </p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}